import React from 'react';
import CountUp from 'react-countup';

// Keeping this here in case we need to handle very large numbers
// Will need some tweaking to work as smoothly as without it due to rounding

// const formatter = (num) => {
//   const lookup = [
//     { value: 1e9, symbol: 'G' },
//     { value: 1e6, symbol: 'M' },
//     { value: 1e3, symbol: 'k' },
//     { value: 1, symbol: '' }
//   ];

//   const item = lookup.find((suffix) => num >= suffix.value);
//   if (!item) return '0';

//   const formattedNum = Math.floor(num / item.value);
//   return `${formattedNum}${item.symbol}`.replace(/\.0$/, '');
// };

const Statistic = ({ title, value, prefix, suffix }) => (
  <div className="statistic">
    <span className="statistic-value">
      {prefix}
      <CountUp
        start={0}
        end={value}
        duration={4}
        enableScrollSpy
        scrollSpyOnce
        // formattingFn={(num) => formatter(num)}
      >
        {({ countUpRef }) => <span ref={countUpRef} />}
      </CountUp>
      <noscript>{value}</noscript>
      {suffix}
    </span>
    <span className="statistic-title">{title}</span>
  </div>
);

export default Statistic;
